module.exports = __webpack_public_path__ + "static/media/keyplan.6147bcf9.png";